module.exports = __webpack_public_path__ + "static/media/solution-img6.e1897bc8.png";